<app-logout-dialog></app-logout-dialog>
<div class="flex flex-col h-[95vh] ml-4 bg-white rounded-lg border-[1px] border-border overflow-y-auto"
    [ngClass]="getSidebarState() ? 'w-64 transition-[width] duration-200 ease-in-out' : 'w-20 transition-[width] duration-500 ease-in-out'">
    <div class="my-4 mx-4 flex items-center" (mouseenter)="hoverSidebar(true)" (click)="hoverSidebarChange()"
        (mouseleave)="hoverSidebar(false)" [ngClass]="!getSidebarState() ? 'justify-center' : 'justify-between'">
        <app-logo width="90" height="40" [ngClass]="!getSidebarState() ? 'hidden' : ''"></app-logo>
        <img src="assets/icons/small-logo.svg" class="w-[30px] h-[32px]"
            alt="{{ 'shared.components.logo_alt' | transloco}}"
            [ngClass]="!getSidebarState() ? 'justify-self-center' : 'hidden'">
        <button (click)="toggleSidebar()" title="{{ 'shared.collapse_sidebar' | transloco}}"
            [ngClass]="!getSidebarOpenState() ? 'hidden' : 'hover:bg-primary-200 rounded-md px-2 py-2'"><img
                [src]='!getSidebarOpenState() ? "assets/icons/sidebar/arrow-right.svg" : "assets/icons/sidebar/arrow-left.svg"'
                class="pr-4" alt="{{ 'shared.components.hide' | transloco}}"></button>

        <button *ngIf="getSidebarState() && !getSidebarOpenState()" (click)="toggleSidebar()"
            class="hover:bg-primary-200 text-sm text-primary border border-primary rounded-[16px] px-2 py-1">
            {{'shared.fix_navigation' | transloco}}
        </button>


    </div>
    @if(hasDashboardViewPermission)
    {
    <a routerLink="/dashboard" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.dashboard' | transloco }}"
        [ngClass]="[selectedItemId == 0 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 0 ? 'assets/icons/sidebar/dashboard-selected.svg' : 'assets/icons/sidebar/dashboard.svg'"
            class="" alt="{{ 'shared.pages.dashboard' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.dashboard' | transloco }}</span>
    </a>
    }
    <a routerLink="/invoice" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.invoice_check' | transloco }}"
        [ngClass]="[selectedItemId == 1 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 1 ? 'assets/icons/sidebar/invoice-check-selected.svg' : 'assets/icons/sidebar/invoice-check.svg'"
            class="" alt="{{ 'shared.pages.invoice_check' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.invoice_check' | transloco }}</span>
    </a>
    <!-- 
    TODO: DSantek - Show optimization link when Non-Group clients are available
    Optimization section is hidden for product launch.
    <a routerLink="/optimization" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.optimization' | transloco }}"
        [ngClass]="[selectedItemId == 2 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]="selectedItemId == 2 ? 'assets/icons/sidebar/optimization-selected.svg' : 'assets/icons/sidebar/optimization.svg'"
            class="" alt="{{ 'shared.pages.optimization' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.optimization' | transloco }}</span>
    </a>
    -->
    <a routerLink="/services" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.services' | transloco }}"
        [ngClass]="[selectedItemId == 3 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 3 ? 'assets/icons/sidebar/solar-selected.svg' : 'assets/icons/sidebar/solar.svg'"
            class="" alt="{{ 'shared.pages.services' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.services' | transloco }}</span>
    </a>
    <a routerLink="/locations" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.locations' | transloco }}"
        [ngClass]="[selectedItemId == 4 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 4 ? 'assets/icons/sidebar/locations-selected.svg' : 'assets/icons/sidebar/locations.svg'"
            class="" alt="{{ 'shared.pages.locations' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.locations' | transloco }}</span>
    </a>
    <a routerLink="/archive" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.archive' | transloco }}"
        [ngClass]="[selectedItemId == 5 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 5 ? 'assets/icons/sidebar/archive-selected.svg' : 'assets/icons/sidebar/archive.svg'"
            class="" alt="{{ 'shared.pages.archive' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.archive' | transloco }}</span>
    </a>

    <button (click)="toggleSidebar()" title="{{ 'shared.expand_sidebar' | transloco}}"
        [ngClass]="!getSidebarState() ? 'mt-auto flex items-center justify-center rounded-md hover:bg-primary-200 py-4 px-4' : 'hidden'"><img
            src="assets/icons/sidebar/arrow-right.svg" alt="{{ 'shared.components.show' | transloco}}"></button>

    <a routerLink="/file-upload" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.file_upload' | transloco }}"
        [ngClass]="[selectedItemId == 12 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? 'mt-auto' : 'mt-0', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 12 ? 'assets/icons/sidebar/file-upload-selected.svg' : 'assets/icons/sidebar/file-upload.svg'"
            class="" alt="{{ 'shared.pages.file_upload' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.file_upload' | transloco }}</span>
    </a>
    <a routerLink="/settings" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" title="{{ 'shared.pages.settings' | transloco }}"
        [ngClass]="[selectedItemId == 13 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 13 ? 'assets/icons/sidebar/settings-selected.svg' : 'assets/icons/sidebar/settings.svg'"
            class="" alt="{{ 'shared.pages.settings' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.pages.settings' | transloco }}</span>
    </a>
    <button class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200" (click)="logoutUser()"
        title="{{ 'shared.components.logout' | transloco }}"
        [ngClass]="[selectedItemId == 14 ? 'text-primary' : 'text-neutral-500', getSidebarState() ? '' : 'justify-center']">
        <img [src]=" selectedItemId == 14 ? 'assets/icons/sidebar/logout-selected.svg' : 'assets/icons/sidebar/logout.svg'"
            class="" alt="{{ 'shared.components.logout' | transloco }}">
        <span [ngClass]="!getSidebarState() ? 'hidden' : 'pl-4'">{{ 'shared.components.logout' | transloco }}</span>
    </button>

    <div class="py-4 px-4 flex flex-col gap-2 justify-center items-center" *ngIf="isUserOnTrial">
        <div class="flex gap-2 w-full items-center justify-start">
            @if (getSidebarState()) {
            <div class="px-4 py-2 bg-primary-200 rounded-[16px] font-semibold text-center text-primary text-lg">
                {{trialDaysLeft}}
            </div>}
            @else {
            <button class="px-4 py-2 bg-primary-200 rounded-[16px] font-semibold text-center text-primary text-lg"
                (click)="openPlansPage()" title="{{ 'shared.add_billing' | transloco }}">
                {{trialDaysLeft}}
            </button>
            }
            <p *ngIf="getSidebarState()">{{ 'shared.days_left_on_trial' | transloco }}</p>
        </div>

        <div class="w-full h-[50px]" *ngIf="getSidebarState()">
            <app-primary-button buttonText="{{ 'shared.add_billing' | transloco }}"
                (buttonClick)="openPlansPage()"></app-primary-button>
        </div>
    </div>
</div>